import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
  ApplicationFormSettings, AssignChipNumbersResponse,
  Competitor,
  CompetitorFilter, Country,
  EventItem,
  Lookups,
  PagedFilter, Pages, Race,
  RaceSettings,
  AssignChipNumbersRequest,
  TOAST_STATE
} from "@model";
import {AssignChipNumbersModalComponent, CompetitorTableType} from "@components";
import {CompetitorService, EventService, LoaderService, ToastService} from "@services";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {TranslocoService} from "@ngneat/transloco";
import { ORGANISER_MEASUREMENTS_MANAGEMENT} from 'src/app/app-routing.module';
import {Router} from '@angular/router';

@Component({
  selector: 'app-event-management-participants-list',
  templateUrl: './event-management-participants-list.component.html',
  styleUrl: './event-management-participants-list.component.scss'
})
export class EventManagementParticipantsListComponent {

  @Input() filter: PagedFilter<CompetitorFilter> | undefined;
  @Input() searchForm: any;
  @Input() event: EventItem | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) countries: Country[] = [];
  @Input({required: true}) disableRegisterToRace: boolean = false;
  @Input() genders: Lookups[] = [];
  @Input() raceSettingsList: RaceSettings[] = [];
  @Input() applicationFormSettingsList: ApplicationFormSettings[] = []
  @Input() competitors: Competitor[] = [];
  @Input() measurements: boolean = false;
  @Output() registerToRace: EventEmitter<void> = new EventEmitter<void>();
  @Output() printStartList: EventEmitter<void> = new EventEmitter<void>();
  @Output() getFileFromServer: EventEmitter<{ type: string, filter: PagedFilter<CompetitorFilter> | undefined }>
    = new EventEmitter<{ type: string, filter: PagedFilter<CompetitorFilter> | undefined }>();
  @Output() chronometarRaceCompetitorStartStop = new EventEmitter<Race>();
  @Output() refreshCounters = new EventEmitter<void>();

  page: number = 1;

  constructor(private modalService: NgbModal, private translocoService: TranslocoService,
              private toastService: ToastService, private competitorService: CompetitorService, private eventService: EventService, private router: Router,
              private loaderService: LoaderService) {
  }

  onFilterChange(filter: PagedFilter<CompetitorFilter> | undefined): void {
    this.filter = filter;
  }

  onRegisterToRace() {
    this.registerToRace.next();
  }

  goToEventMeasurements(): void {
    if (this.event?.id) {
      this.eventService.setCurrentEvent(this.event);
      this.router.navigate([ORGANISER_MEASUREMENTS_MANAGEMENT], {queryParams: {eventId: this.event.id}});
    }
  }

  onGetFileFromServer(type: string) {
    this.getFileFromServer.next({type: type, filter: this.filter});
  }

  onPrintStartList() {
    this.printStartList.next();
  }

  onChronometarRaceCompetitorStartStop(race:Race) {
    this.chronometarRaceCompetitorStartStop.emit(race);
  }

  assignChipNumber() {
    const modalRef = this.modalService.open(AssignChipNumbersModalComponent, {
      centered: true,
      size: 'lg',
    });
    modalRef.componentInstance.title = this.translocoService.translate("race.management.competitors.assign.chip.numbers");
    modalRef.componentInstance.event = this.event;
    modalRef.result.then((request: AssignChipNumbersRequest) => {
      this.onAssignChipNumber(request);
    }, (_) => {
      /// ignore
    });
  }

  onAssignChipNumber(request: AssignChipNumbersRequest): void {
    this.loaderService.startLoading()
    const onSuccess = (result: AssignChipNumbersResponse) => {
      this.loaderService.dismissLoading();

      const { state, message } = AssignChipNumbersResponse.buildToastMessage(
          result,
          (key) => this.translocoService.translate(key)
      );

      this.toastService.showToast(state, message);

      this.competitorService.findCompetitors(new PagedFilter(new Pages(), {
        raceId: undefined,
        eventId: this.event?.id
      }), true, this.measurements).subscribe((value) => {
            this.loaderService.dismissLoading();
            this.competitors = value;
            this.filter = new PagedFilter(new Pages(undefined, this.page), new CompetitorFilter())
          }
      );
    }
    const onError = (result: number | undefined) => {
      this.loaderService.dismissLoading();
      if (result === CompetitorService.INVALID_CHIP_NUMBER) {
        this.toastService.showToast(TOAST_STATE.danger,
            this.translocoService.translate("race.management.competitors.assign.chip.invalid.chip.number.error"));
      } else {
        this.toastService.showToast(TOAST_STATE.danger,
            this.translocoService.translate("race.management.competitors.assign.chip.numbers.error"));
      }
    }
    this.competitorService.assignChipNumbers(this.event?.id, request, onSuccess, onError)
  }

  onRefreshCounters() {
    this.refreshCounters.emit();
  }


  protected readonly CompetitorTableType = CompetitorTableType;
}
